import type { ImageType } from '@/core/features/image-v2/image-type';

import { HtmlTextWrapper, Image, Link, ResponsiveImage } from '@/core/features';
import { trackActivityTilesClick } from '@/features/activity-tiles/activity-tiles-tracking';

import styles from './activity-tile-v1.module.scss';

type ActivityTileProps = {
    height: number;
    image: ImageType;
    linkUrl: string;
    subtitle?: null | string;
    title: string;
    width: '100%' | number;
};

export default function ActivityTile({ height, image, linkUrl, subtitle, title, width }: ActivityTileProps) {
    return (
        <div className={'relative'}>
            <div
                className={`${styles.activityTile} shadow`}
                style={{ height, width }}
            >
                <Link
                    fullWidth={true}
                    href={linkUrl}
                    linkType={'internal'}
                    onClick={() => trackActivityTilesClick(title)}
                    qaId={'qa-search-page-link'}
                >
                    <div className={styles.titleWrapper}>
                        <HtmlTextWrapper
                            className={styles.title}
                            htmlText={title}
                        />
                        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
                    </div>
                    {width === '100%' ? (
                        <ResponsiveImage
                            alt={image.imageAlt}
                            height={height}
                            layoutWidth={100}
                            preload={true}
                            url={image.imageUrl}
                        />
                    ) : (
                        <Image
                            alt={image.imageAlt}
                            height={height}
                            preload={true}
                            url={image.imageUrl}
                            width={width}
                        />
                    )}
                </Link>
            </div>
        </div>
    );
}
